webpackJsonp([1,11],{

/***/ 10:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(13)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(11),
	  /* template */
	  __webpack_require__(15),
	  /* scopeId */
	  "data-v-23a5876e",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 11:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    props: ['title', 'marginTop', 'noPadding'],
	    computed: {
	        contentMarginTop: function contentMarginTop() {
	            if (this.marginTop) {
	                return this.marginTop;
	            } else {
	                return 0;
	            }
	        }
	    }
	};

/***/ }),

/***/ 12:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)();
	// imports
	
	
	// module
	exports.push([module.id, ".blank[data-v-23a5876e]{visibility:hidden;height:0}.content-item[data-v-23a5876e]{width:1080px;min-height:200px;margin:30px auto;background:#fff;border-top:7px solid #f5972d;border-left:1px solid #bdbdbd;border-right:1px solid #bdbdbd;box-shadow:0 2px 6px #ccc;position:relative}.content-item .edge-line[data-v-23a5876e]{font-size:0;line-height:0;margin-left:35%;border-top:5px solid #f5972d;border-left:20px solid transparent;box-sizing:border-box}.content-item .wrapper[data-v-23a5876e]{width:100%;padding:30px;box-sizing:border-box}.content-item .no-padding[data-v-23a5876e]{padding:0!important;margin-top:-5px!important}.header[data-v-23a5876e]{width:100%;height:30px;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;-ms-grid-row-align:center;align-items:center;margin-bottom:35px}.header .item-icon[data-v-23a5876e]{width:30px;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0}.header .title[data-v-23a5876e]{font-size:30px;font-weight:700;color:#f5972d;height:42px;line-height:42px;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0}.header .title[data-v-23a5876e]:before{content:\" \";display:inline-block;width:17.68px;height:17.68px;transform:rotate(45deg);background:#f5972d;margin:3px 7px}.header .line-arrow[data-v-23a5876e]{-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:1;flex-shrink:1;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;-ms-grid-row-align:center;align-items:center}.header .line-arrow .line[data-v-23a5876e]{height:1px;width:100px;margin:0 5px;background:#f5972d;-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:1;flex-shrink:1}.header .line-arrow .arrow[data-v-23a5876e]{width:32px;height:24px;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;cursor:pointer;background:url(" + __webpack_require__(14) + ")}.content[data-v-23a5876e]{width:100%;margin:0 auto;box-sizing:border-box}", "", {"version":3,"sources":["/./src/components/partial/ContentItem.vue"],"names":[],"mappings":"AACA,wBAAwB,kBAAkB,QAAQ,CACjD,AACD,+BAA+B,aAAa,iBAAiB,iBAAiB,gBAAgB,6BAA6B,8BAA8B,+BAA+B,0BAA0B,iBAAiB,CAClO,AACD,0CAA0C,YAAY,cAAc,gBAAgB,6BAA6B,mCAAmC,qBAAqB,CACxK,AACD,wCAAwC,WAAW,aAAa,qBAAqB,CACpF,AACD,2CAA2C,oBAAqB,yBAA0B,CACzF,AACD,yBAAyB,WAAW,YAAY,oBAAoB,aAAa,qBAAqB,uBAAuB,yBAAyB,2BAA2B,sBAAsB,0BAA0B,mBAAmB,kBAAkB,CACrQ,AACD,oCAAoC,WAAW,oBAAoB,YAAY,oBAAoB,aAAa,CAC/G,AACD,gCAAgC,eAAe,gBAAiB,cAAc,YAAY,iBAAiB,oBAAoB,YAAY,oBAAoB,aAAa,CAC3K,AACD,uCAAwC,YAAY,qBAAqB,cAAc,eAAe,wBAAwB,mBAAmB,cAAkB,CAClK,AACD,qCAAqC,oBAAoB,YAAY,oBAAoB,cAAc,oBAAoB,aAAa,qBAAqB,uBAAuB,yBAAyB,2BAA2B,sBAAsB,0BAA0B,kBAAkB,CACzS,AACD,2CAA2C,WAAW,YAAY,aAAa,mBAAmB,oBAAoB,YAAY,oBAAoB,aAAa,CAClK,AACD,4CAA4C,WAAW,YAAY,oBAAoB,YAAY,oBAAoB,cAAc,eAAe,wCAA4D,CAC/M,AACD,0BAA0B,WAAW,cAAc,qBAAqB,CACvE","file":"ContentItem.vue","sourcesContent":["\n.blank[data-v-23a5876e]{visibility:hidden;height:0\n}\n.content-item[data-v-23a5876e]{width:1080px;min-height:200px;margin:30px auto;background:#fff;border-top:7px solid #f5972d;border-left:1px solid #bdbdbd;border-right:1px solid #bdbdbd;box-shadow:0 2px 6px #ccc;position:relative\n}\n.content-item .edge-line[data-v-23a5876e]{font-size:0;line-height:0;margin-left:35%;border-top:5px solid #f5972d;border-left:20px solid transparent;box-sizing:border-box\n}\n.content-item .wrapper[data-v-23a5876e]{width:100%;padding:30px;box-sizing:border-box\n}\n.content-item .no-padding[data-v-23a5876e]{padding:0 !important;margin-top:-5px !important\n}\n.header[data-v-23a5876e]{width:100%;height:30px;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;-ms-grid-row-align:center;align-items:center;margin-bottom:35px\n}\n.header .item-icon[data-v-23a5876e]{width:30px;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0\n}\n.header .title[data-v-23a5876e]{font-size:30px;font-weight:bold;color:#f5972d;height:42px;line-height:42px;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0\n}\n.header .title[data-v-23a5876e]::before{content:' ';display:inline-block;width:17.68px;height:17.68px;transform:rotate(45deg);background:#f5972d;margin:3px 7px 3px\n}\n.header .line-arrow[data-v-23a5876e]{-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:1;flex-shrink:1;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;-ms-grid-row-align:center;align-items:center\n}\n.header .line-arrow .line[data-v-23a5876e]{height:1px;width:100px;margin:0 5px;background:#f5972d;-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:1;flex-shrink:1\n}\n.header .line-arrow .arrow[data-v-23a5876e]{width:32px;height:24px;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;cursor:pointer;background:url(../../../static/img/partial/right_arrows.png)\n}\n.content[data-v-23a5876e]{width:100%;margin:0 auto;box-sizing:border-box\n}\n"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ }),

/***/ 13:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(12);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-23a5876e&scoped=true!../../../node_modules/sass-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ContentItem.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-23a5876e&scoped=true!../../../node_modules/sass-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./ContentItem.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 14:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAYCAMAAACsjQ8GAAAAeFBMVEUAAACtra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra2tra1N9hVJAAAAJ3RSTlMABgr59Ouc0MWlf3FKJRwVD+PLv7eTimUs3drVYT4yW1c3GrCqhUJHseVLAAABH0lEQVQoz2WS27KCMAxFS+V+UUQBRVD0HO3//6E7MzvWjnlaGTLD6k5M6pzrImNMD8gsoAScW6MV5ehThcKg/gBH86ltgn4E7PaACtBOgNJPLBvnNnfAXWABnGJM1H6iQrvfAUZA8gCsgLjxEwX6g4iKcS4wAC7WaNkM/SCiHaAXOAL+AaxGRFc1nsX4TGNWDb/4pMZXwDUGvPiZ6Uztt/EsxlvDYjqBcc+MWW3CdGyixhMzlpIMOHBzHKidHxAn/qIB4Bd8UGc1iYkrtBklo5ySmiWfmTo+cxB4BQI3FZgpwKB0e70KiNcj+Y7aXugFAVkWBfyyCg0vVa9nsO7Z8WBWgUUF6kBgVIFKBcpAIBXIeLTRQTL7LOH37J/B2b8BNk8tU7z0QeYAAAAASUVORK5CYII="

/***/ }),

/***/ 15:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "content-item",
	    style: ('margin-top: ' + _vm.contentMarginTop + 'px')
	  }, [_c('div', {
	    staticClass: "edge-line"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "wrapper",
	    class: _vm.noPadding ? 'no-padding' : ''
	  }, [(_vm.title) ? _c('div', {
	    staticClass: "header"
	  }, [_c('div', {
	    staticClass: "title"
	  }, [_vm._v("\n                " + _vm._s(_vm.title) + "\n            ")]), _vm._v(" "), _vm._m(0)]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "content"
	  }, [_vm._t("default")], 2)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "line-arrow"
	  }, [_c('div', {
	    staticClass: "line"
	  })])
	}]}

/***/ }),

/***/ 112:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(308)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(154),
	  /* template */
	  __webpack_require__(386),
	  /* scopeId */
	  "data-v-944db24e",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 142:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _Carousel = __webpack_require__(351);
	
	var _Carousel2 = _interopRequireDefault(_Carousel);
	
	var _GameNews = __webpack_require__(352);
	
	var _GameNews2 = _interopRequireDefault(_GameNews);
	
	var _HotGames = __webpack_require__(353);
	
	var _HotGames2 = _interopRequireDefault(_HotGames);
	
	var _Partner = __webpack_require__(354);
	
	var _Partner2 = _interopRequireDefault(_Partner);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    components: {
	        Carousel: _Carousel2.default,
	        GameNews: _GameNews2.default,
	        HotGames: _HotGames2.default,
	        Partner: _Partner2.default
	    }
	};

/***/ }),

/***/ 149:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _blueimpMd = __webpack_require__(17);
	
	var _blueimpMd2 = _interopRequireDefault(_blueimpMd);
	
	var _global = __webpack_require__(22);
	
	var _global2 = _interopRequireDefault(_global);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    data: function data() {
	        return {
	            sliders: [],
	            show_flag: false
	        };
	    },
	    created: function created() {
	        if (_global2.default.methods.getStorageItem('carouselData')) {
	            this.show_flag = true;
	            this.sliders = JSON.parse(_global2.default.methods.getStorageItem('carouselData'));
	            return;
	        }
	        var timeStamp = Date.parse(new Date());
	        var sign = (0, _blueimpMd2.default)(timeStamp);
	        var that = this;
	
	        var extraParam = '&platform=2';
	        if (_global2.default.isTest) {
	            extraParam += '&isTest=1';
	        }
	        this.$http.get(_global2.default.enjoyUrl + 'enjoysiteapi/getcarousel?timestamp=' + timeStamp + '&sign=' + sign + extraParam).then(function (response) {
	            that.sliders = response.data;
	            that.show_flag = true;
	            _global2.default.methods.setStorageItem('carouselData', that.sliders);
	        });
	    },
	
	    methods: {
	        imgAnimation: function imgAnimation(sliderIndex) {
	            var index = sliderIndex + 1;
	            $('.item-img').hide();
	            $('.item-desc').hide();
	
	            setTimeout(function () {
	                $('.item-img' + index).fadeIn();
	                setTimeout(function () {
	                    $('.item-desc' + index).fadeIn();
	                }, 600);
	            }, 600);
	        }
	    }
	};

/***/ }),

/***/ 150:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _blueimpMd = __webpack_require__(17);
	
	var _blueimpMd2 = _interopRequireDefault(_blueimpMd);
	
	var _global = __webpack_require__(22);
	
	var _global2 = _interopRequireDefault(_global);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    data: function data() {
	
	        return {
	            allAppNews: [],
	            allNews: []
	
	        };
	    },
	    methods: {
	        openWeb: function openWeb(url) {
	            window.open(url);
	        }
	    },
	    beforeMount: function beforeMount() {
	        if (_global2.default.methods.getStorageItem('nearNewsData')) {
	            var tmp = JSON.parse(_global2.default.methods.getStorageItem('nearNewsData'));
	            this.allAppNews = tmp.resApp;
	            this.allNews = tmp.resNews;
	            return;
	        }
	        var timeStamp = Date.parse(new Date());
	        var sign = (0, _blueimpMd2.default)(timeStamp);
	        var that = this;
	        var extraParam = '&platform=2';
	        if (_global2.default.isTest) {
	            extraParam += '&isTest=1';
	        }
	        this.$http.get(_global2.default.enjoyUrl + 'enjoysiteapi/getnearnews?timestamp=' + timeStamp + '&sign=' + sign + extraParam).then(function (response) {
	            that.allAppNews = response.data.resApp;
	            that.allNews = response.data.resNews;
	            if (that.allNews.length == 0) {
	                _global2.default.methods.setStorageItem('nearNewsData', response.data);
	                return;
	            }
	            if (that.allNews[0].title.length > 20) {
	                that.allNews[0].title = that.allNews[0].title.substr(0, 20) + '...';
	            }
	            _global2.default.methods.setStorageItem('nearNewsData', response.data);
	        });
	    }
	};

/***/ }),

/***/ 151:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _PartItem = __webpack_require__(112);
	
	var _PartItem2 = _interopRequireDefault(_PartItem);
	
	var _blueimpMd = __webpack_require__(17);
	
	var _blueimpMd2 = _interopRequireDefault(_blueimpMd);
	
	var _global = __webpack_require__(22);
	
	var _global2 = _interopRequireDefault(_global);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    data: function data() {
	        return {
	            allGames: [],
	            currentGames: []
	        };
	    },
	    components: {
	        PartItem: _PartItem2.default
	    },
	    methods: {
	        openWeb: function openWeb(url) {
	            window.open(url);
	        },
	        shuffle: function shuffle(array) {
	            var currentIndex = array.length,
	                temporaryValue = void 0,
	                randomIndex = void 0;
	            while (0 !== currentIndex) {
	                randomIndex = Math.floor(Math.random() * currentIndex);
	                currentIndex -= 1;
	                temporaryValue = array[currentIndex];
	                array[currentIndex] = array[randomIndex];
	                array[randomIndex] = temporaryValue;
	            }
	            return array;
	        },
	        shuffleGames: function shuffleGames() {
	            this.currentGames = this.shuffle(this.allGames).slice(0, 3);
	        },
	        getData: function getData() {
	            if (_global2.default.methods.getStorageItem('hotGameData')) {
	                this.allGames = JSON.parse(_global2.default.methods.getStorageItem('hotGameData'));
	                this.currentGames = this.allGames.slice(0, 3);
	                return;
	            }
	            var timeStamp = Date.parse(new Date());
	            var sign = (0, _blueimpMd2.default)(timeStamp);
	            var that = this;
	            var extraParam = '&platform=2';
	            if (_global2.default.isTest) {
	                extraParam += '&isTest=1';
	            }
	            this.$http.get(_global2.default.enjoyUrl + 'enjoysiteapi/gethotgame?timestamp=' + timeStamp + '&sign=' + sign + extraParam).then(function (response) {
	                that.allGames = response.data;
	                that.currentGames = that.allGames.slice(0, 3);
	                _global2.default.methods.setStorageItem('hotGameData', that.allGames);
	            });
	        }
	    },
	    created: function created() {
	        this.getData();
	    }
	};

/***/ }),

/***/ 152:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _PartItem = __webpack_require__(112);
	
	var _PartItem2 = _interopRequireDefault(_PartItem);
	
	var _ContentItem = __webpack_require__(10);
	
	var _ContentItem2 = _interopRequireDefault(_ContentItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    data: function data() {
	        return {};
	    },
	    methods: {
	        showIcon: function showIcon(row, col) {
	            if (row == 1 && col == 5) {
	                return false;
	            }
	            if (row == 2 && (col == 2 || col == 6)) {
	                return false;
	            }
	            if (row == 3 && col == 4) {
	                return false;
	            }
	            if (row == 4 && (col == 2 || col == 7)) {
	                return false;
	            }
	            return true;
	        }
	    },
	    components: {
	        PartItem: _PartItem2.default,
	        ContentItem: _ContentItem2.default
	    }
	};

/***/ }),

/***/ 154:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    props: ['title']
	};

/***/ }),

/***/ 246:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)();
	// imports
	
	
	// module
	exports.push([module.id, ".blank[data-v-43bba9cf]{visibility:hidden;height:0}.refresh[data-v-43bba9cf]{font-size:17px;margin-right:15px;cursor:pointer}.refresh .fa-refresh[data-v-43bba9cf]{font-size:22px;margin-left:5px;color:#f5972d}.component-fade-enter-active[data-v-43bba9cf],.component-fade-leave-active[data-v-43bba9cf]{transition:opacity .3s ease}.component-fade-enter[data-v-43bba9cf],.component-fade-leave-active[data-v-43bba9cf]{opacity:0}.hot-games[data-v-43bba9cf]{height:283px;display:-ms-flexbox;display:flex;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;-ms-grid-row-align:center;align-items:center}.hot-games .hot-game[data-v-43bba9cf]{height:288px;width:342px;position:relative;box-shadow:0 5px 5px 0 hsla(0,0%,56%,.75)}.hot-games .hot-game .top-bg[data-v-43bba9cf]{width:342px;height:156px;cursor:pointer}.hot-games .hot-game .top-bg:hover .game-qr[data-v-43bba9cf]{height:156px;opacity:1;transition:all .2s linear}.hot-games .hot-game .top-bg .game-qr[data-v-43bba9cf]{transition:all .2s linear;opacity:.5;width:342px;height:0;background:rgba(255,170,35,.9);position:absolute;top:0;overflow:hidden}.hot-games .hot-game .top-bg .game-qr .qr-container[data-v-43bba9cf]{display:-ms-flexbox;display:flex;padding:30px}.hot-games .hot-game .top-bg .game-qr .qr[data-v-43bba9cf]{width:100px;height:100px}.hot-games .hot-game .top-bg .game-qr .left-qr[data-v-43bba9cf]{width:100px;height:100px;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0}.hot-games .hot-game .top-bg .game-qr .right-desc[data-v-43bba9cf]{margin-left:15px;height:106px;-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:1;flex-shrink:1;overflow:hidden;font-size:15px;color:#fff;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;justify-content:center;-webkit-box-align:start;-webkit-align-items:flex-start;-ms-flex-align:start;-ms-grid-row-align:flex-start;align-items:flex-start}.hot-games .hot-game .top-bg .game-qr .right-desc .rating[data-v-43bba9cf]{margin:5px 0}.hot-games .hot-game .top-bg .game-qr .right-desc .rating .stars[data-v-43bba9cf],.hot-games .hot-game .top-bg .game-qr .right-desc .rating[data-v-43bba9cf]{display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;-ms-grid-row-align:center;align-items:center}.hot-games .hot-game .bottom-desc[data-v-43bba9cf]{height:127px;padding:15px 30px;box-sizing:border-box;overflow:hidden}.hot-games .hot-game .bottom-desc .game-title[data-v-43bba9cf]{font-size:19px;height:25px;margin-bottom:5px}.hot-games .hot-game .bottom-desc .game-desc[data-v-43bba9cf]{font-size:14px;color:#8f8c8c;height:40px;overflow:hidden}.hot-games .hot-game .bottom-desc .links[data-v-43bba9cf]{display:-ms-flexbox;display:flex;-ms-flex-pack:end;justify-content:flex-end;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;-ms-grid-row-align:center;align-items:center;margin-top:7px}.hot-games .hot-game .bottom-desc .links .link-heart[data-v-43bba9cf]{color:#8f8c8c;cursor:pointer}.hot-games .hot-game .bottom-desc .links .link-heart[data-v-43bba9cf]:hover{color:red}.hot-games .hot-game .bottom-desc .links .link-btn[data-v-43bba9cf]{display:block;width:94px;height:30px;line-height:30px;text-align:center;border:1px solid #b1b1b1;color:#8f8c8c;font-weight:700;font-size:15px;margin-left:10px;box-sizing:border-box;text-decoration:none}.hot-games .hot-game .bottom-desc .links .link-btn[data-v-43bba9cf]:hover{background:#ffaa23;color:#fff;cursor:pointer;border:none;transition:all .2s ease-in-out}", "", {"version":3,"sources":["/./src/components/home/HotGames.vue"],"names":[],"mappings":"AACA,wBAAwB,kBAAkB,QAAQ,CACjD,AACD,0BAA0B,eAAe,kBAAkB,cAAc,CACxE,AACD,sCAAsC,eAAe,gBAAgB,aAAa,CACjF,AACD,4FAA4F,2BAA2B,CACtH,AACD,qFAAqF,SAAS,CAC7F,AACD,4BAA4B,aAAa,oBAAoB,aAAa,sBAAsB,8BAA8B,yBAAyB,2BAA2B,sBAAsB,0BAA0B,kBAAkB,CACnP,AACD,sCAAsC,aAAa,YAAY,kBAAkB,yCAA6C,CAC7H,AACD,8CAA8C,YAAY,aAAa,cAAc,CACpF,AACD,6DAA6D,aAAa,UAAU,yBAAyB,CAC5G,AACD,uDAAuD,0BAA0B,WAAY,YAAY,SAAS,+BAAgC,kBAAkB,MAAM,eAAe,CACxL,AACD,qEAAqE,oBAAoB,aAAa,YAAY,CACjH,AACD,2DAA2D,YAAY,YAAY,CAClF,AACD,gEAAgE,YAAY,aAAa,oBAAoB,YAAY,oBAAoB,aAAa,CACzJ,AACD,mEAAmE,iBAAiB,aAAa,oBAAoB,YAAY,oBAAoB,cAAc,gBAAgB,eAAe,WAAW,oBAAoB,aAAa,0BAA0B,sBAAsB,qBAAqB,uBAAuB,wBAAwB,+BAA+B,qBAAqB,8BAA8B,sBAAsB,CACzc,AACD,2EAA+Q,YAAY,CAC1R,AACD,6JAF2E,oBAAoB,aAAa,qBAAqB,uBAAuB,yBAAyB,2BAA2B,sBAAsB,0BAA0B,kBAAmB,CAG9Q,AACD,mDAAmD,aAAa,kBAAkB,sBAAsB,eAAe,CACtH,AACD,+DAA+D,eAAe,YAAY,iBAAiB,CAC1G,AACD,8DAA8D,eAAe,cAAc,YAAY,eAAe,CACrH,AACD,0DAA0D,oBAAoB,aAAa,kBAAkB,yBAAyB,yBAAyB,2BAA2B,sBAAsB,0BAA0B,mBAAmB,cAAc,CAC1Q,AACD,sEAAsE,cAAc,cAAc,CACjG,AACD,4EAA4E,SAAS,CACpF,AACD,oEAAoE,cAAc,WAAW,YAAY,iBAAiB,kBAAkB,yBAAyB,cAAc,gBAAiB,eAAe,iBAAiB,sBAAsB,oBAAoB,CAC7Q,AACD,0EAA0E,mBAAmB,WAAW,eAAe,YAAY,8BAA8B,CAChK","file":"HotGames.vue","sourcesContent":["\n.blank[data-v-43bba9cf]{visibility:hidden;height:0\n}\n.refresh[data-v-43bba9cf]{font-size:17px;margin-right:15px;cursor:pointer\n}\n.refresh .fa-refresh[data-v-43bba9cf]{font-size:22px;margin-left:5px;color:#f5972d\n}\n.component-fade-enter-active[data-v-43bba9cf],.component-fade-leave-active[data-v-43bba9cf]{transition:opacity .3s ease\n}\n.component-fade-enter[data-v-43bba9cf],.component-fade-leave-active[data-v-43bba9cf]{opacity:0\n}\n.hot-games[data-v-43bba9cf]{height:283px;display:-ms-flexbox;display:flex;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;-ms-grid-row-align:center;align-items:center\n}\n.hot-games .hot-game[data-v-43bba9cf]{height:288px;width:342px;position:relative;box-shadow:0 5px 5px 0 rgba(143,143,143,0.75)\n}\n.hot-games .hot-game .top-bg[data-v-43bba9cf]{width:342px;height:156px;cursor:pointer\n}\n.hot-games .hot-game .top-bg:hover .game-qr[data-v-43bba9cf]{height:156px;opacity:1;transition:all .2s linear\n}\n.hot-games .hot-game .top-bg .game-qr[data-v-43bba9cf]{transition:all .2s linear;opacity:0.5;width:342px;height:0;background:rgba(255,170,35,0.9);position:absolute;top:0;overflow:hidden\n}\n.hot-games .hot-game .top-bg .game-qr .qr-container[data-v-43bba9cf]{display:-ms-flexbox;display:flex;padding:30px\n}\n.hot-games .hot-game .top-bg .game-qr .qr[data-v-43bba9cf]{width:100px;height:100px\n}\n.hot-games .hot-game .top-bg .game-qr .left-qr[data-v-43bba9cf]{width:100px;height:100px;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0\n}\n.hot-games .hot-game .top-bg .game-qr .right-desc[data-v-43bba9cf]{margin-left:15px;height:106px;-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:1;flex-shrink:1;overflow:hidden;font-size:15px;color:#fff;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;justify-content:center;-webkit-box-align:start;-webkit-align-items:flex-start;-ms-flex-align:start;-ms-grid-row-align:flex-start;align-items:flex-start\n}\n.hot-games .hot-game .top-bg .game-qr .right-desc .rating[data-v-43bba9cf]{display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;-ms-grid-row-align:center;align-items:center;margin:5px 0\n}\n.hot-games .hot-game .top-bg .game-qr .right-desc .rating .stars[data-v-43bba9cf]{display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;-ms-grid-row-align:center;align-items:center\n}\n.hot-games .hot-game .bottom-desc[data-v-43bba9cf]{height:127px;padding:15px 30px;box-sizing:border-box;overflow:hidden\n}\n.hot-games .hot-game .bottom-desc .game-title[data-v-43bba9cf]{font-size:19px;height:25px;margin-bottom:5px\n}\n.hot-games .hot-game .bottom-desc .game-desc[data-v-43bba9cf]{font-size:14px;color:#8f8c8c;height:40px;overflow:hidden\n}\n.hot-games .hot-game .bottom-desc .links[data-v-43bba9cf]{display:-ms-flexbox;display:flex;-ms-flex-pack:end;justify-content:flex-end;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;-ms-grid-row-align:center;align-items:center;margin-top:7px\n}\n.hot-games .hot-game .bottom-desc .links .link-heart[data-v-43bba9cf]{color:#8f8c8c;cursor:pointer\n}\n.hot-games .hot-game .bottom-desc .links .link-heart[data-v-43bba9cf]:hover{color:red\n}\n.hot-games .hot-game .bottom-desc .links .link-btn[data-v-43bba9cf]{display:block;width:94px;height:30px;line-height:30px;text-align:center;border:1px solid #b1b1b1;color:#8f8c8c;font-weight:bold;font-size:15px;margin-left:10px;box-sizing:border-box;text-decoration:none\n}\n.hot-games .hot-game .bottom-desc .links .link-btn[data-v-43bba9cf]:hover{background:#ffaa23;color:#fff;cursor:pointer;border:none;transition:all .2s ease-in-out\n}\n"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ }),

/***/ 250:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)();
	// imports
	
	
	// module
	exports.push([module.id, ".blank[data-v-5a027f44]{visibility:hidden;height:0}.home-page[data-v-5a027f44]{padding-bottom:30px}.top-content[data-v-5a027f44]{width:100%;height:967px;margin:0 auto;position:relative}", "", {"version":3,"sources":["/./src/components/Home.vue"],"names":[],"mappings":"AACA,wBAAwB,kBAAkB,QAAQ,CACjD,AACD,4BAA4B,mBAAmB,CAC9C,AACD,8BAA8B,WAAW,aAAa,cAAc,iBAAiB,CACpF","file":"Home.vue","sourcesContent":["\n.blank[data-v-5a027f44]{visibility:hidden;height:0\n}\n.home-page[data-v-5a027f44]{padding-bottom:30px\n}\n.top-content[data-v-5a027f44]{width:100%;height:967px;margin:0 auto;position:relative\n}\n"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ }),

/***/ 256:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)();
	// imports
	
	
	// module
	exports.push([module.id, ".blank[data-v-944db24e]{visibility:hidden;height:0}.part-item[data-v-944db24e]{width:1080px;margin:45px auto}.item-header[data-v-944db24e]{display:-ms-flexbox;display:flex;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;-ms-grid-row-align:center;align-items:center;width:100%;height:80px;margin-top:-40px}.part-item-title[data-v-944db24e]{transform:rotate(45deg);font-size:22px;margin-right:10px}.item-title[data-v-944db24e]{color:#f5972d;font-size:26px}", "", {"version":3,"sources":["/./src/components/partial/PartItem.vue"],"names":[],"mappings":"AACA,wBAAwB,kBAAkB,QAAQ,CACjD,AACD,4BAA4B,aAAa,gBAAgB,CACxD,AACD,8BAA8B,oBAAoB,aAAa,sBAAsB,8BAA8B,yBAAyB,2BAA2B,sBAAsB,0BAA0B,mBAAmB,WAAW,YAAY,gBAAgB,CAChR,AACD,kCAAkC,wBAAwB,eAAe,iBAAiB,CACzF,AACD,6BAA6B,cAAc,cAAc,CACxD","file":"PartItem.vue","sourcesContent":["\n.blank[data-v-944db24e]{visibility:hidden;height:0\n}\n.part-item[data-v-944db24e]{width:1080px;margin:45px auto\n}\n.item-header[data-v-944db24e]{display:-ms-flexbox;display:flex;-ms-flex-pack:justify;justify-content:space-between;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;-ms-grid-row-align:center;align-items:center;width:100%;height:80px;margin-top:-40px\n}\n.part-item-title[data-v-944db24e]{transform:rotate(45deg);font-size:22px;margin-right:10px\n}\n.item-title[data-v-944db24e]{color:#f5972d;font-size:26px\n}\n"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ }),

/***/ 260:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)();
	// imports
	
	
	// module
	exports.push([module.id, ".blank[data-v-c2b5e786]{visibility:hidden;height:0}.partner-content[data-v-c2b5e786]{margin:30px auto}.partner-content .hex-row[data-v-c2b5e786]{display:-ms-flexbox;display:flex;margin-top:-18px;margin-left:5px}.partner-content .hex-row .hex-col[data-v-c2b5e786]{margin-right:14px}.partner-content .hex-row .hex-col[data-v-c2b5e786]:last-child{margin-right:0}.partner-content .hex-gap[data-v-c2b5e786]{margin-left:62px}.icon15[data-v-c2b5e786]{position:relative;width:100px;height:60px;background-color:#ff6262!important;border-left:1px solid #ff6262!important;border-right:1px solid #ff6262!important;margin:27.71px 0;transform:rotate(-60deg)}.icon15[data-v-c2b5e786]:hover{box-shadow:0 0 20px hsla(0,0%,79%,.65)}.icon15[data-v-c2b5e786]:hover:after,.icon15[data-v-c2b5e786]:hover:before{box-shadow:0 0 20px #ff6262!important}.icon15[data-v-c2b5e786]:after,.icon15[data-v-c2b5e786]:before{content:\"\";position:absolute;z-index:1;width:69px;height:69px;transform:scaleY(.5774) rotate(-45deg);background-color:inherit;left:14.0589px}.icon15[data-v-c2b5e786]:before{top:-35px;border-top:1.4142px solid #ff6262!important;border-right:1.4142px solid #ff6262!important;background:#ff9191!important}.icon15[data-v-c2b5e786]:after{bottom:-35.85px;border-bottom:1.4142px solid #ff6262!important;border-left:1.4142px solid #ff6262!important}.icon15 .content[data-v-c2b5e786]{display:block;position:absolute;top:.5773502691896257px;left:0;width:100%;height:60px;z-index:2;background:inherit;overflow:hidden;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;-ms-grid-row-align:center;align-items:center}.icon15 .content .icon[data-v-c2b5e786]{max-height:50px;max-width:85px}.icon22[data-v-c2b5e786]{position:relative;width:100px;height:60px;background-color:#fd8b4c!important;border-left:1px solid #fd8b4c!important;border-right:1px solid #fd8b4c!important;margin:27.71px 0;transform:rotate(-60deg)}.icon22[data-v-c2b5e786]:hover{box-shadow:0 0 20px hsla(0,0%,79%,.65)}.icon22[data-v-c2b5e786]:hover:after,.icon22[data-v-c2b5e786]:hover:before{box-shadow:0 0 20px #fd8b4c!important}.icon22[data-v-c2b5e786]:after,.icon22[data-v-c2b5e786]:before{content:\"\";position:absolute;z-index:1;width:69px;height:69px;transform:scaleY(.5774) rotate(-45deg);background-color:inherit;left:14.0589px}.icon22[data-v-c2b5e786]:before{top:-35px;border-top:1.4142px solid #fd8b4c!important;border-right:1.4142px solid #fd8b4c!important;background:#feae82!important}.icon22[data-v-c2b5e786]:after{bottom:-35.85px;border-bottom:1.4142px solid #fd8b4c!important;border-left:1.4142px solid #fd8b4c!important}.icon22 .content[data-v-c2b5e786]{display:block;position:absolute;top:.5773502691896257px;left:0;width:100%;height:60px;z-index:2;background:inherit;overflow:hidden;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;-ms-grid-row-align:center;align-items:center}.icon22 .content .icon[data-v-c2b5e786]{max-height:50px;max-width:85px}.icon26[data-v-c2b5e786]{position:relative;width:100px;height:60px;background-color:#ec54a9!important;border-left:1px solid #ec54a9!important;border-right:1px solid #ec54a9!important;margin:27.71px 0;transform:rotate(120deg)}.icon26[data-v-c2b5e786]:hover{box-shadow:0 0 20px hsla(0,0%,79%,.65)}.icon26[data-v-c2b5e786]:hover:after,.icon26[data-v-c2b5e786]:hover:before{box-shadow:0 0 20px #ec54a9!important}.icon26[data-v-c2b5e786]:after,.icon26[data-v-c2b5e786]:before{content:\"\";position:absolute;z-index:1;width:69px;height:69px;transform:scaleY(.5774) rotate(-45deg);background-color:inherit;left:14.0589px}.icon26[data-v-c2b5e786]:before{top:-35px;border-top:1.4142px solid #ec54a9!important;border-right:1.4142px solid #ec54a9!important;background:#f288c3!important}.icon26[data-v-c2b5e786]:after{bottom:-35.85px;border-bottom:1.4142px solid #ec54a9!important;border-left:1.4142px solid #ec54a9!important}.icon26 .content[data-v-c2b5e786]{display:block;position:absolute;top:.5773502691896257px;left:0;width:100%;height:60px;z-index:2;background:inherit;overflow:hidden;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;-ms-grid-row-align:center;align-items:center}.icon26 .content .icon[data-v-c2b5e786]{max-height:50px;max-width:85px}.icon34[data-v-c2b5e786]{position:relative;width:100px;height:60px;background-color:#12a765!important;border-left:1px solid #12a765!important;border-right:1px solid #12a765!important;margin:27.71px 0}.icon34[data-v-c2b5e786]:hover{box-shadow:0 0 20px hsla(0,0%,79%,.65)}.icon34[data-v-c2b5e786]:hover:after,.icon34[data-v-c2b5e786]:hover:before{box-shadow:0 0 20px #12a765!important}.icon34[data-v-c2b5e786]:after,.icon34[data-v-c2b5e786]:before{content:\"\";position:absolute;z-index:1;width:69px;height:69px;transform:scaleY(.5774) rotate(-45deg);background-color:inherit;left:14.0589px}.icon34[data-v-c2b5e786]:before{top:-35px;border-top:1.4142px solid #12a765!important;border-right:1.4142px solid #12a765!important;background:#5ac294!important}.icon34[data-v-c2b5e786]:after{bottom:-35.85px;border-bottom:1.4142px solid #12a765!important;border-left:1.4142px solid #12a765!important}.icon34 .content[data-v-c2b5e786]{display:block;position:absolute;top:.5773502691896257px;left:0;width:100%;height:60px;z-index:2;background:inherit;overflow:hidden;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;-ms-grid-row-align:center;align-items:center}.icon34 .content .icon[data-v-c2b5e786]{max-height:50px;max-width:85px}.icon42[data-v-c2b5e786]{position:relative;width:100px;height:60px;background-color:#3683c7!important;border-left:1px solid #3683c7!important;border-right:1px solid #3683c7!important;margin:27.71px 0;transform:rotate(-60deg)}.icon42[data-v-c2b5e786]:hover{box-shadow:0 0 20px hsla(0,0%,79%,.65)}.icon42[data-v-c2b5e786]:hover:after,.icon42[data-v-c2b5e786]:hover:before{box-shadow:0 0 20px #3683c7!important}.icon42[data-v-c2b5e786]:after,.icon42[data-v-c2b5e786]:before{content:\"\";position:absolute;z-index:1;width:69px;height:69px;transform:scaleY(.5774) rotate(-45deg);background-color:inherit;left:14.0589px}.icon42[data-v-c2b5e786]:before{top:-35px;border-top:1.4142px solid #3683c7!important;border-right:1.4142px solid #3683c7!important;background:#73a8d8!important}.icon42[data-v-c2b5e786]:after{bottom:-35.85px;border-bottom:1.4142px solid #3683c7!important;border-left:1.4142px solid #3683c7!important}.icon42 .content[data-v-c2b5e786]{display:block;position:absolute;top:.5773502691896257px;left:0;width:100%;height:60px;z-index:2;background:inherit;overflow:hidden;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;-ms-grid-row-align:center;align-items:center}.icon42 .content .icon[data-v-c2b5e786]{max-height:50px;max-width:85px}.icon47[data-v-c2b5e786]{position:relative;width:100px;height:60px;background-color:#def068!important;border-left:1px solid #def068!important;border-right:1px solid #def068!important;margin:27.71px 0}.icon47[data-v-c2b5e786]:hover{box-shadow:0 0 20px hsla(0,0%,79%,.65)}.icon47[data-v-c2b5e786]:hover:after,.icon47[data-v-c2b5e786]:hover:before{box-shadow:0 0 20px #def068!important}.icon47[data-v-c2b5e786]:after,.icon47[data-v-c2b5e786]:before{content:\"\";position:absolute;z-index:1;width:69px;height:69px;transform:scaleY(.5774) rotate(-45deg);background-color:inherit;left:14.0589px}.icon47[data-v-c2b5e786]:before{top:-35px;border-top:1.4142px solid #def068!important;border-right:1.4142px solid #def068!important;background:#e8f596!important}.icon47[data-v-c2b5e786]:after{bottom:-35.85px;border-bottom:1.4142px solid #def068!important;border-left:1.4142px solid #def068!important}.icon47 .content[data-v-c2b5e786]{display:block;position:absolute;top:.5773502691896257px;left:0;width:100%;height:60px;z-index:2;background:inherit;overflow:hidden;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;-ms-grid-row-align:center;align-items:center}.icon47 .content .icon[data-v-c2b5e786]{max-height:50px;max-width:85px}.hexagon[data-v-c2b5e786]{position:relative;width:100px;height:60px;background-color:#fff;border-left:1px solid #cacaca;border-right:1px solid #cacaca;margin:27.71px 0}.hexagon[data-v-c2b5e786]:hover,.hexagon[data-v-c2b5e786]:hover:after,.hexagon[data-v-c2b5e786]:hover:before{box-shadow:0 0 20px hsla(0,0%,79%,.65)}.hexagon[data-v-c2b5e786]:after,.hexagon[data-v-c2b5e786]:before{content:\"\";position:absolute;z-index:1;width:69px;height:69px;transform:scaleY(.5774) rotate(-45deg);background-color:inherit;left:14.0589px}.hexagon[data-v-c2b5e786]:before{top:-35px;border-top:1.4142px solid #cacaca;border-right:1.4142px solid #cacaca;background:!important}.hexagon[data-v-c2b5e786]:after{bottom:-35.85px;border-bottom:1.4142px solid #cacaca;border-left:1.4142px solid #cacaca}.hexagon .content[data-v-c2b5e786]{display:block;position:absolute;top:.5773502691896257px;left:0;width:100%;height:60px;z-index:2;background:inherit;overflow:hidden;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;-ms-grid-row-align:center;align-items:center}.hexagon .content .icon[data-v-c2b5e786]{max-height:50px;max-width:85px}", "", {"version":3,"sources":["/./src/components/home/Partner.vue"],"names":[],"mappings":"AACA,wBAAwB,kBAAkB,QAAQ,CACjD,AACD,kCAAkC,gBAAgB,CACjD,AACD,2CAA2C,oBAAoB,aAAa,iBAAiB,eAAe,CAC3G,AACD,oDAAoD,iBAAiB,CACpE,AACD,+DAA+D,cAAc,CAC5E,AACD,2CAA2C,gBAAgB,CAC1D,AACD,yBAAyB,kBAAkB,YAAY,YAAY,mCAAoC,wCAAyC,yCAA0C,iBAAiB,wBAAwB,CAClO,AACD,+BAA+B,sCAA0C,CACxE,AACD,2EAA2E,qCAAsC,CAChH,AACD,+DAA+D,WAAW,kBAAkB,UAAU,WAAW,YAAY,uCAAwC,yBAAyB,cAAc,CAC3M,AACD,gCAAiC,UAAU,4CAA6C,8CAA+C,4BAA6B,CACnK,AACD,+BAA+B,gBAAgB,+CAAgD,4CAA6C,CAC3I,AACD,kCAAkC,cAAc,kBAAkB,wBAAyB,OAAO,WAAW,YAAY,UAAU,mBAAmB,gBAAgB,oBAAoB,aAAa,qBAAqB,uBAAuB,yBAAyB,2BAA2B,sBAAsB,0BAA0B,kBAAkB,CACxW,AACD,wCAAwC,gBAAgB,cAAc,CACrE,AACD,yBAAyB,kBAAkB,YAAY,YAAY,mCAAoC,wCAAyC,yCAA0C,iBAAiB,wBAAwB,CAClO,AACD,+BAA+B,sCAA0C,CACxE,AACD,2EAA2E,qCAAsC,CAChH,AACD,+DAA+D,WAAW,kBAAkB,UAAU,WAAW,YAAY,uCAAwC,yBAAyB,cAAc,CAC3M,AACD,gCAAiC,UAAU,4CAA6C,8CAA+C,4BAA6B,CACnK,AACD,+BAA+B,gBAAgB,+CAAgD,4CAA6C,CAC3I,AACD,kCAAkC,cAAc,kBAAkB,wBAAyB,OAAO,WAAW,YAAY,UAAU,mBAAmB,gBAAgB,oBAAoB,aAAa,qBAAqB,uBAAuB,yBAAyB,2BAA2B,sBAAsB,0BAA0B,kBAAkB,CACxW,AACD,wCAAwC,gBAAgB,cAAc,CACrE,AACD,yBAAyB,kBAAkB,YAAY,YAAY,mCAAoC,wCAAyC,yCAA0C,iBAAiB,wBAAwB,CAClO,AACD,+BAA+B,sCAA0C,CACxE,AACD,2EAA2E,qCAAsC,CAChH,AACD,+DAA+D,WAAW,kBAAkB,UAAU,WAAW,YAAY,uCAAwC,yBAAyB,cAAc,CAC3M,AACD,gCAAiC,UAAU,4CAA6C,8CAA+C,4BAA6B,CACnK,AACD,+BAA+B,gBAAgB,+CAAgD,4CAA6C,CAC3I,AACD,kCAAkC,cAAc,kBAAkB,wBAAyB,OAAO,WAAW,YAAY,UAAU,mBAAmB,gBAAgB,oBAAoB,aAAa,qBAAqB,uBAAuB,yBAAyB,2BAA2B,sBAAsB,0BAA0B,kBAAkB,CACxW,AACD,wCAAwC,gBAAgB,cAAc,CACrE,AACD,yBAAyB,kBAAkB,YAAY,YAAY,mCAAoC,wCAAyC,yCAA0C,gBAAgB,CACzM,AACD,+BAA+B,sCAA0C,CACxE,AACD,2EAA2E,qCAAsC,CAChH,AACD,+DAA+D,WAAW,kBAAkB,UAAU,WAAW,YAAY,uCAAwC,yBAAyB,cAAc,CAC3M,AACD,gCAAiC,UAAU,4CAA6C,8CAA+C,4BAA6B,CACnK,AACD,+BAA+B,gBAAgB,+CAAgD,4CAA6C,CAC3I,AACD,kCAAkC,cAAc,kBAAkB,wBAAyB,OAAO,WAAW,YAAY,UAAU,mBAAmB,gBAAgB,oBAAoB,aAAa,qBAAqB,uBAAuB,yBAAyB,2BAA2B,sBAAsB,0BAA0B,kBAAkB,CACxW,AACD,wCAAwC,gBAAgB,cAAc,CACrE,AACD,yBAAyB,kBAAkB,YAAY,YAAY,mCAAoC,wCAAyC,yCAA0C,iBAAiB,wBAAwB,CAClO,AACD,+BAA+B,sCAA0C,CACxE,AACD,2EAA2E,qCAAsC,CAChH,AACD,+DAA+D,WAAW,kBAAkB,UAAU,WAAW,YAAY,uCAAwC,yBAAyB,cAAc,CAC3M,AACD,gCAAiC,UAAU,4CAA6C,8CAA+C,4BAA6B,CACnK,AACD,+BAA+B,gBAAgB,+CAAgD,4CAA6C,CAC3I,AACD,kCAAkC,cAAc,kBAAkB,wBAAyB,OAAO,WAAW,YAAY,UAAU,mBAAmB,gBAAgB,oBAAoB,aAAa,qBAAqB,uBAAuB,yBAAyB,2BAA2B,sBAAsB,0BAA0B,kBAAkB,CACxW,AACD,wCAAwC,gBAAgB,cAAc,CACrE,AACD,yBAAyB,kBAAkB,YAAY,YAAY,mCAAoC,wCAAyC,yCAA0C,gBAAgB,CACzM,AACD,+BAA+B,sCAA0C,CACxE,AACD,2EAA2E,qCAAsC,CAChH,AACD,+DAA+D,WAAW,kBAAkB,UAAU,WAAW,YAAY,uCAAwC,yBAAyB,cAAc,CAC3M,AACD,gCAAiC,UAAU,4CAA6C,8CAA+C,4BAA6B,CACnK,AACD,+BAA+B,gBAAgB,+CAAgD,4CAA6C,CAC3I,AACD,kCAAkC,cAAc,kBAAkB,wBAAyB,OAAO,WAAW,YAAY,UAAU,mBAAmB,gBAAgB,oBAAoB,aAAa,qBAAqB,uBAAuB,yBAAyB,2BAA2B,sBAAsB,0BAA0B,kBAAkB,CACxW,AACD,wCAAwC,gBAAgB,cAAc,CACrE,AACD,0BAA0B,kBAAkB,YAAY,YAAY,sBAAsB,8BAA8B,+BAA+B,gBAAgB,CACtK,AAGD,6GAA6E,sCAA0C,CACtH,AACD,iEAAiE,WAAW,kBAAkB,UAAU,WAAW,YAAY,uCAAwC,yBAAyB,cAAc,CAC7M,AACD,iCAAkC,UAAU,kCAAkC,oCAAoC,qBAAqB,CACtI,AACD,gCAAgC,gBAAgB,qCAAqC,kCAAkC,CACtH,AACD,mCAAmC,cAAc,kBAAkB,wBAAyB,OAAO,WAAW,YAAY,UAAU,mBAAmB,gBAAgB,oBAAoB,aAAa,qBAAqB,uBAAuB,yBAAyB,2BAA2B,sBAAsB,0BAA0B,kBAAkB,CACzW,AACD,yCAAyC,gBAAgB,cAAc,CACtE","file":"Partner.vue","sourcesContent":["\n.blank[data-v-c2b5e786]{visibility:hidden;height:0\n}\n.partner-content[data-v-c2b5e786]{margin:30px auto\n}\n.partner-content .hex-row[data-v-c2b5e786]{display:-ms-flexbox;display:flex;margin-top:-18px;margin-left:5px\n}\n.partner-content .hex-row .hex-col[data-v-c2b5e786]{margin-right:14px\n}\n.partner-content .hex-row .hex-col[data-v-c2b5e786]:last-child{margin-right:0\n}\n.partner-content .hex-gap[data-v-c2b5e786]{margin-left:62px\n}\n.icon15[data-v-c2b5e786]{position:relative;width:100px;height:60px;background-color:#ff6262 !important;border-left:solid 1px #ff6262 !important;border-right:solid 1px #ff6262 !important;margin:27.71px 0;transform:rotate(-60deg)\n}\n.icon15[data-v-c2b5e786]:hover{box-shadow:0 0 20px rgba(202,202,202,0.65)\n}\n.icon15[data-v-c2b5e786]:hover:before,.icon15[data-v-c2b5e786]:hover:after{box-shadow:0 0 20px #ff6262 !important\n}\n.icon15[data-v-c2b5e786]:before,.icon15[data-v-c2b5e786]:after{content:\"\";position:absolute;z-index:1;width:69px;height:69px;transform:scaleY(0.5774) rotate(-45deg);background-color:inherit;left:14.0589px\n}\n.icon15[data-v-c2b5e786]::before{top:-35px;border-top:solid 1.4142px #ff6262 !important;border-right:solid 1.4142px #ff6262 !important;background:#ff9191 !important\n}\n.icon15[data-v-c2b5e786]:after{bottom:-35.85px;border-bottom:solid 1.4142px #ff6262 !important;border-left:solid 1.4142px #ff6262 !important\n}\n.icon15 .content[data-v-c2b5e786]{display:block;position:absolute;top:0.5773502691896257px;left:0;width:100%;height:60px;z-index:2;background:inherit;overflow:hidden;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;-ms-grid-row-align:center;align-items:center\n}\n.icon15 .content .icon[data-v-c2b5e786]{max-height:50px;max-width:85px\n}\n.icon22[data-v-c2b5e786]{position:relative;width:100px;height:60px;background-color:#fd8b4c !important;border-left:solid 1px #fd8b4c !important;border-right:solid 1px #fd8b4c !important;margin:27.71px 0;transform:rotate(-60deg)\n}\n.icon22[data-v-c2b5e786]:hover{box-shadow:0 0 20px rgba(202,202,202,0.65)\n}\n.icon22[data-v-c2b5e786]:hover:before,.icon22[data-v-c2b5e786]:hover:after{box-shadow:0 0 20px #fd8b4c !important\n}\n.icon22[data-v-c2b5e786]:before,.icon22[data-v-c2b5e786]:after{content:\"\";position:absolute;z-index:1;width:69px;height:69px;transform:scaleY(0.5774) rotate(-45deg);background-color:inherit;left:14.0589px\n}\n.icon22[data-v-c2b5e786]::before{top:-35px;border-top:solid 1.4142px #fd8b4c !important;border-right:solid 1.4142px #fd8b4c !important;background:#feae82 !important\n}\n.icon22[data-v-c2b5e786]:after{bottom:-35.85px;border-bottom:solid 1.4142px #fd8b4c !important;border-left:solid 1.4142px #fd8b4c !important\n}\n.icon22 .content[data-v-c2b5e786]{display:block;position:absolute;top:0.5773502691896257px;left:0;width:100%;height:60px;z-index:2;background:inherit;overflow:hidden;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;-ms-grid-row-align:center;align-items:center\n}\n.icon22 .content .icon[data-v-c2b5e786]{max-height:50px;max-width:85px\n}\n.icon26[data-v-c2b5e786]{position:relative;width:100px;height:60px;background-color:#ec54a9 !important;border-left:solid 1px #ec54a9 !important;border-right:solid 1px #ec54a9 !important;margin:27.71px 0;transform:rotate(120deg)\n}\n.icon26[data-v-c2b5e786]:hover{box-shadow:0 0 20px rgba(202,202,202,0.65)\n}\n.icon26[data-v-c2b5e786]:hover:before,.icon26[data-v-c2b5e786]:hover:after{box-shadow:0 0 20px #ec54a9 !important\n}\n.icon26[data-v-c2b5e786]:before,.icon26[data-v-c2b5e786]:after{content:\"\";position:absolute;z-index:1;width:69px;height:69px;transform:scaleY(0.5774) rotate(-45deg);background-color:inherit;left:14.0589px\n}\n.icon26[data-v-c2b5e786]::before{top:-35px;border-top:solid 1.4142px #ec54a9 !important;border-right:solid 1.4142px #ec54a9 !important;background:#f288c3 !important\n}\n.icon26[data-v-c2b5e786]:after{bottom:-35.85px;border-bottom:solid 1.4142px #ec54a9 !important;border-left:solid 1.4142px #ec54a9 !important\n}\n.icon26 .content[data-v-c2b5e786]{display:block;position:absolute;top:0.5773502691896257px;left:0;width:100%;height:60px;z-index:2;background:inherit;overflow:hidden;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;-ms-grid-row-align:center;align-items:center\n}\n.icon26 .content .icon[data-v-c2b5e786]{max-height:50px;max-width:85px\n}\n.icon34[data-v-c2b5e786]{position:relative;width:100px;height:60px;background-color:#12a765 !important;border-left:solid 1px #12a765 !important;border-right:solid 1px #12a765 !important;margin:27.71px 0\n}\n.icon34[data-v-c2b5e786]:hover{box-shadow:0 0 20px rgba(202,202,202,0.65)\n}\n.icon34[data-v-c2b5e786]:hover:before,.icon34[data-v-c2b5e786]:hover:after{box-shadow:0 0 20px #12a765 !important\n}\n.icon34[data-v-c2b5e786]:before,.icon34[data-v-c2b5e786]:after{content:\"\";position:absolute;z-index:1;width:69px;height:69px;transform:scaleY(0.5774) rotate(-45deg);background-color:inherit;left:14.0589px\n}\n.icon34[data-v-c2b5e786]::before{top:-35px;border-top:solid 1.4142px #12a765 !important;border-right:solid 1.4142px #12a765 !important;background:#5ac294 !important\n}\n.icon34[data-v-c2b5e786]:after{bottom:-35.85px;border-bottom:solid 1.4142px #12a765 !important;border-left:solid 1.4142px #12a765 !important\n}\n.icon34 .content[data-v-c2b5e786]{display:block;position:absolute;top:0.5773502691896257px;left:0;width:100%;height:60px;z-index:2;background:inherit;overflow:hidden;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;-ms-grid-row-align:center;align-items:center\n}\n.icon34 .content .icon[data-v-c2b5e786]{max-height:50px;max-width:85px\n}\n.icon42[data-v-c2b5e786]{position:relative;width:100px;height:60px;background-color:#3683c7 !important;border-left:solid 1px #3683c7 !important;border-right:solid 1px #3683c7 !important;margin:27.71px 0;transform:rotate(-60deg)\n}\n.icon42[data-v-c2b5e786]:hover{box-shadow:0 0 20px rgba(202,202,202,0.65)\n}\n.icon42[data-v-c2b5e786]:hover:before,.icon42[data-v-c2b5e786]:hover:after{box-shadow:0 0 20px #3683c7 !important\n}\n.icon42[data-v-c2b5e786]:before,.icon42[data-v-c2b5e786]:after{content:\"\";position:absolute;z-index:1;width:69px;height:69px;transform:scaleY(0.5774) rotate(-45deg);background-color:inherit;left:14.0589px\n}\n.icon42[data-v-c2b5e786]::before{top:-35px;border-top:solid 1.4142px #3683c7 !important;border-right:solid 1.4142px #3683c7 !important;background:#73a8d8 !important\n}\n.icon42[data-v-c2b5e786]:after{bottom:-35.85px;border-bottom:solid 1.4142px #3683c7 !important;border-left:solid 1.4142px #3683c7 !important\n}\n.icon42 .content[data-v-c2b5e786]{display:block;position:absolute;top:0.5773502691896257px;left:0;width:100%;height:60px;z-index:2;background:inherit;overflow:hidden;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;-ms-grid-row-align:center;align-items:center\n}\n.icon42 .content .icon[data-v-c2b5e786]{max-height:50px;max-width:85px\n}\n.icon47[data-v-c2b5e786]{position:relative;width:100px;height:60px;background-color:#def068 !important;border-left:solid 1px #def068 !important;border-right:solid 1px #def068 !important;margin:27.71px 0\n}\n.icon47[data-v-c2b5e786]:hover{box-shadow:0 0 20px rgba(202,202,202,0.65)\n}\n.icon47[data-v-c2b5e786]:hover:before,.icon47[data-v-c2b5e786]:hover:after{box-shadow:0 0 20px #def068 !important\n}\n.icon47[data-v-c2b5e786]:before,.icon47[data-v-c2b5e786]:after{content:\"\";position:absolute;z-index:1;width:69px;height:69px;transform:scaleY(0.5774) rotate(-45deg);background-color:inherit;left:14.0589px\n}\n.icon47[data-v-c2b5e786]::before{top:-35px;border-top:solid 1.4142px #def068 !important;border-right:solid 1.4142px #def068 !important;background:#e8f596 !important\n}\n.icon47[data-v-c2b5e786]:after{bottom:-35.85px;border-bottom:solid 1.4142px #def068 !important;border-left:solid 1.4142px #def068 !important\n}\n.icon47 .content[data-v-c2b5e786]{display:block;position:absolute;top:0.5773502691896257px;left:0;width:100%;height:60px;z-index:2;background:inherit;overflow:hidden;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;-ms-grid-row-align:center;align-items:center\n}\n.icon47 .content .icon[data-v-c2b5e786]{max-height:50px;max-width:85px\n}\n.hexagon[data-v-c2b5e786]{position:relative;width:100px;height:60px;background-color:#fff;border-left:solid 1px #cacaca;border-right:solid 1px #cacaca;margin:27.71px 0\n}\n.hexagon[data-v-c2b5e786]:hover{box-shadow:0 0 20px rgba(202,202,202,0.65)\n}\n.hexagon[data-v-c2b5e786]:hover:before,.hexagon[data-v-c2b5e786]:hover:after{box-shadow:0 0 20px rgba(202,202,202,0.65)\n}\n.hexagon[data-v-c2b5e786]:before,.hexagon[data-v-c2b5e786]:after{content:\"\";position:absolute;z-index:1;width:69px;height:69px;transform:scaleY(0.5774) rotate(-45deg);background-color:inherit;left:14.0589px\n}\n.hexagon[data-v-c2b5e786]::before{top:-35px;border-top:solid 1.4142px #cacaca;border-right:solid 1.4142px #cacaca;background:!important\n}\n.hexagon[data-v-c2b5e786]:after{bottom:-35.85px;border-bottom:solid 1.4142px #cacaca;border-left:solid 1.4142px #cacaca\n}\n.hexagon .content[data-v-c2b5e786]{display:block;position:absolute;top:0.5773502691896257px;left:0;width:100%;height:60px;z-index:2;background:inherit;overflow:hidden;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;-ms-grid-row-align:center;align-items:center\n}\n.hexagon .content .icon[data-v-c2b5e786]{max-height:50px;max-width:85px\n}\n"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ }),

/***/ 262:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)();
	// imports
	
	
	// module
	exports.push([module.id, ".blank[data-v-d50b428a]{visibility:hidden;height:0}.page-home-carousel .el-carousel .el-carousel__container .el-carousel__item[data-v-d50b428a]{opacity:0!important;transition:all .2s ease-out!important;transform:none!important;background-repeat:no-repeat;background-size:100% 757px}.page-home-carousel .el-carousel .el-carousel__container .is-active[data-v-d50b428a]{opacity:1!important;transition:all .2s ease-in!important;transform:none!important}.item-content[data-v-d50b428a]{width:1080px;height:757px;margin:0 auto;position:relative}.item-content .item-img[data-v-d50b428a]{position:absolute;right:-270px;z-index:9;display:none;background-repeat:no-repeat;background-position:top;background-size:700px 734px;width:700px;height:734px}.item-desc[data-v-d50b428a]{height:500px;position:absolute;z-index:10;top:65px;left:30px}.item-desc h1.game-title[data-v-d50b428a]{color:#fff;text-shadow:0 0 .3em #ffbb81,0 0 .3em #ffbb81;width:600px;word-wrap:break-word;word-break:break-all}.item-desc p.game-desc[data-v-d50b428a]{color:#fff;text-shadow:0 0 .5em #ffbb81,0 0 .5em #ffbb81}.item-desc .game-logo[data-v-d50b428a]{height:150px}.item-desc .game-title[data-v-d50b428a]{color:#252525;font-size:42px}.item-desc .orange-line[data-v-d50b428a]{height:2px;background:#f5972d;margin-top:5px}.item-desc .game-desc[data-v-d50b428a]{margin:10px 10px 0 0;color:#333;font-size:16px;line-height:28px;width:493px}.item-desc .detail-link[data-v-d50b428a]{display:block;width:126px;height:42px;background:#ffaa23;color:#fff;font-size:16px;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;-ms-grid-row-align:center;align-items:center;text-decoration:none;cursor:pointer;margin-top:40px;border:1px solid #fff;box-sizing:border-box}", "", {"version":3,"sources":["/./src/components/home/Carousel.vue"],"names":[],"mappings":"AACA,wBAAwB,kBAAkB,QAAQ,CACjD,AACD,6FAA6F,oBAAqB,sCAAuC,yBAA0B,4BAA4B,0BAA0B,CACxO,AACD,qFAAqF,oBAAqB,qCAAsC,wBAAyB,CACxK,AACD,+BAA+B,aAAa,aAAa,cAAc,iBAAiB,CACvF,AACD,yCAAyC,kBAAkB,aAAa,UAAU,aAAa,4BAA4B,wBAA+B,4BAA4B,YAAY,YAAY,CAC7M,AACD,4BAA4B,aAAa,kBAAkB,WAAW,SAAS,SAAS,CACvF,AACD,0CAA0C,WAAW,8CAAmD,YAAY,qBAAqB,oBAAoB,CAC5J,AACD,wCAAwC,WAAW,6CAAkD,CACpG,AACD,uCAAuC,YAAY,CAClD,AACD,wCAAwC,cAAc,cAAc,CACnE,AACD,yCAAyC,WAAW,mBAAmB,cAAc,CACpF,AACD,uCAAuC,qBAAqB,WAAc,eAAe,iBAAiB,WAAW,CACpH,AACD,yCAAyC,cAAc,YAAY,YAAY,mBAAmB,WAAW,eAAe,oBAAoB,aAAa,qBAAqB,uBAAuB,yBAAyB,2BAA2B,sBAAsB,0BAA0B,mBAAmB,qBAAqB,eAAe,gBAAgB,sBAAsB,qBAAqB,CAC9Z","file":"Carousel.vue","sourcesContent":["\n.blank[data-v-d50b428a]{visibility:hidden;height:0\n}\n.page-home-carousel .el-carousel .el-carousel__container .el-carousel__item[data-v-d50b428a]{opacity:0 !important;transition:all .2s ease-out !important;transform:none !important;background-repeat:no-repeat;background-size:100% 757px\n}\n.page-home-carousel .el-carousel .el-carousel__container .is-active[data-v-d50b428a]{opacity:1 !important;transition:all .2s ease-in !important;transform:none !important\n}\n.item-content[data-v-d50b428a]{width:1080px;height:757px;margin:0 auto;position:relative\n}\n.item-content .item-img[data-v-d50b428a]{position:absolute;right:-270px;z-index:9;display:none;background-repeat:no-repeat;background-position:top center;background-size:700px 734px;width:700px;height:734px\n}\n.item-desc[data-v-d50b428a]{height:500px;position:absolute;z-index:10;top:65px;left:30px\n}\n.item-desc h1.game-title[data-v-d50b428a]{color:#fff;text-shadow:0 0 0.3em #ffbb81, -0 -0 0.3em #ffbb81;width:600px;word-wrap:break-word;word-break:break-all\n}\n.item-desc p.game-desc[data-v-d50b428a]{color:#fff;text-shadow:0 0 0.5em #ffbb81, -0 -0 0.5em #ffbb81\n}\n.item-desc .game-logo[data-v-d50b428a]{height:150px\n}\n.item-desc .game-title[data-v-d50b428a]{color:#252525;font-size:42px\n}\n.item-desc .orange-line[data-v-d50b428a]{height:2px;background:#f5972d;margin-top:5px\n}\n.item-desc .game-desc[data-v-d50b428a]{margin:10px 10px 0 0;color:#333333;font-size:16px;line-height:28px;width:493px\n}\n.item-desc .detail-link[data-v-d50b428a]{display:block;width:126px;height:42px;background:#ffaa23;color:#fff;font-size:16px;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;-ms-grid-row-align:center;align-items:center;text-decoration:none;cursor:pointer;margin-top:40px;border:1px solid #fff;box-sizing:border-box\n}\n"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ }),

/***/ 264:
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(2)();
	// imports
	
	
	// module
	exports.push([module.id, ".blank[data-v-e94b9680]{visibility:hidden;height:0}.news-nav[data-v-e94b9680]{height:331px;width:100%;z-index:10;position:absolute;bottom:0}.news-nav .orange-bg[data-v-e94b9680]{height:210px;width:100%;background:#f5972d;position:absolute;bottom:0}.news-nav .news-wrapper[data-v-e94b9680]{height:331px;box-sizing:border-box}.news-nav .news-wrapper .news-container[data-v-e94b9680]{width:1080px;height:331px;margin:0 auto;position:relative}.news-nav .news-wrapper .news-container .news-content[data-v-e94b9680]{position:absolute;z-index:1;width:1080px;height:331px;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;-ms-grid-row-align:center;align-items:center;overflow:hidden}.news-item[data-v-e94b9680]{height:331px;width:312px;cursor:pointer;position:relative;overflow:hidden}.news-item .item-bg-img[data-v-e94b9680]{height:331px;width:322px;background-size:322px 331px;background-position:0 0;margin-left:0;transition:all .3s linear}.news-item .mask[data-v-e94b9680]{position:absolute;left:0;top:0;height:331px;width:312px;background:rgba(0,0,0,.5)}.news-item .bottom-bg[data-v-e94b9680]{opacity:.6;width:100%;height:0;background:#ffab27;position:absolute;bottom:0;transition:all .2s linear}.news-item .content[data-v-e94b9680]{position:absolute;top:0;left:0;height:331px;width:312px;z-index:10;color:#fff;text-align:center}.news-item .content .item-title[data-v-e94b9680]{padding:62px 10px 0;height:86px;box-sizing:border-box;transition:all .2s linear}.news-item .content p[data-v-e94b9680]{box-sizing:border-box;font-size:14px;line-height:20px}.news-item .content .item-desc[data-v-e94b9680]{position:absolute;bottom:125px;width:100%;left:0;top:70%;padding:0 50px;transition:all .2s linear}.news-item .content .item-like[data-v-e94b9680]{position:absolute;bottom:20px;width:100%;font-size:14px;transition:all .2s linear}.news-item .content .item-like[data-v-e94b9680]:hover{font-size:16px;transition:all .2s linear}.news-item .content .item-like:hover .link-heart[data-v-e94b9680]{color:red}.news-item:hover .item-bg-img[data-v-e94b9680]{margin-left:-10px;transition:all .3s linear}.news-item:hover .mask[data-v-e94b9680]{display:none}.news-item:hover .bottom-bg[data-v-e94b9680]{height:115px;opacity:1;transition:all .2s linear}.news-item[data-v-e94b9680]{background-repeat:no-repeat;background-position:top}.news-list[data-v-e94b9680]{height:331px;width:456px;background:#333;position:relative}.news-list .plus[data-v-e94b9680]{color:#fff;position:absolute;top:0;right:0;width:0;height:0;border-top:45px solid #f5972d;border-left:45px solid transparent}.news-list .plus span[data-v-e94b9680]{position:absolute;top:-50px;right:2px;font-size:35px}.news-list .content[data-v-e94b9680]{padding:0 35px;margin-top:45px;box-sizing:border-box}.news-list .content .title[data-v-e94b9680]{font-size:31px;color:#f5972d}.news-list .content .title-empty[data-v-e94b9680]{height:44px}.news-list .content .list[data-v-e94b9680]{width:100%;border-top:1px solid gray;margin-top:10px;list-style:none}.news-list .content .list .li[data-v-e94b9680]{width:100%;margin-top:10px}.news-list .content .list .li a[data-v-e94b9680]{display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;-ms-grid-row-align:center;align-items:center;text-decoration:none}.news-list .content .list .li a .title[data-v-e94b9680]{font-size:14px;color:#a6a6a6;-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:1;flex-shrink:1;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}.news-list .content .list .li a .title[data-v-e94b9680]:hover{color:#fff}.news-list .content .list .li a .date[data-v-e94b9680]{font-size:14px;color:#a6a6a6;width:80px;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;text-align:right}", "", {"version":3,"sources":["/./src/components/home/GameNews.vue"],"names":[],"mappings":"AACA,wBAAwB,kBAAkB,QAAQ,CACjD,AACD,2BAA2B,aAAa,WAAW,WAAW,kBAAkB,QAAQ,CACvF,AACD,sCAAsC,aAAa,WAAW,mBAAmB,kBAAkB,QAAQ,CAC1G,AACD,yCAAyC,aAAa,qBAAqB,CAC1E,AACD,yDAAyD,aAAa,aAAa,cAAc,iBAAiB,CACjH,AACD,uEAAuE,kBAAkB,UAAU,aAAa,aAAa,oBAAoB,aAAa,qBAAqB,uBAAuB,yBAAyB,2BAA2B,sBAAsB,0BAA0B,mBAAmB,eAAe,CAC/U,AACD,4BAA4B,aAAa,YAAY,eAAe,kBAAkB,eAAe,CACpG,AACD,yCAAyC,aAAa,YAAY,4BAA4B,wBAA6B,cAAc,yBAAyB,CACjK,AACD,kCAAkC,kBAAkB,OAAO,MAAM,aAAa,YAAY,yBAA0B,CACnH,AACD,uCAAuC,WAAY,WAAW,SAAS,mBAAmB,kBAAkB,SAAS,yBAAyB,CAC7I,AACD,qCAAqC,kBAAkB,MAAM,OAAO,aAAa,YAAY,WAAW,WAAW,iBAAiB,CACnI,AACD,iDAAiD,oBAAoB,YAAY,sBAAsB,yBAAyB,CAC/H,AACD,uCAAuC,sBAAsB,eAAe,gBAAgB,CAC3F,AACD,gDAAgD,kBAAkB,aAAa,WAAW,OAAO,QAAQ,eAAe,yBAAyB,CAChJ,AACD,gDAAgD,kBAAkB,YAAY,WAAW,eAAe,yBAAyB,CAChI,AACD,sDAAsD,eAAe,yBAAyB,CAC7F,AACD,kEAAkE,SAAS,CAC1E,AACD,+CAA+C,kBAAkB,yBAAyB,CACzF,AACD,wCAAwC,YAAY,CACnD,AACD,6CAA6C,aAAa,UAAU,yBAAyB,CAC5F,AACD,4BAA4B,4BAA4B,uBAA8B,CACrF,AACD,4BAA4B,aAAa,YAAY,gBAAgB,iBAAiB,CACrF,AACD,kCAAkC,WAAW,kBAAkB,MAAM,QAAQ,QAAQ,SAAS,8BAA8B,kCAAkC,CAC7J,AACD,uCAAuC,kBAAkB,UAAU,UAAU,cAAc,CAC1F,AACD,qCAAqC,eAAe,gBAAgB,qBAAqB,CACxF,AACD,4CAA4C,eAAe,aAAa,CACvE,AACD,kDAAkD,WAAW,CAC5D,AACD,2CAA2C,WAAW,0BAA0B,gBAAgB,eAAe,CAC9G,AACD,+CAA+C,WAAW,eAAe,CACxE,AACD,iDAAiD,oBAAoB,aAAa,qBAAqB,uBAAuB,yBAAyB,2BAA2B,sBAAsB,0BAA0B,mBAAmB,oBAAoB,CACxQ,AACD,wDAAwD,eAAe,cAAc,oBAAoB,YAAY,oBAAoB,cAAc,gBAAgB,mBAAmB,sBAAsB,CAC/M,AACD,8DAA8D,UAAU,CACvE,AACD,uDAAuD,eAAe,cAAc,WAAW,oBAAoB,YAAY,oBAAoB,cAAc,gBAAgB,CAChL","file":"GameNews.vue","sourcesContent":["\n.blank[data-v-e94b9680]{visibility:hidden;height:0\n}\n.news-nav[data-v-e94b9680]{height:331px;width:100%;z-index:10;position:absolute;bottom:0\n}\n.news-nav .orange-bg[data-v-e94b9680]{height:210px;width:100%;background:#f5972d;position:absolute;bottom:0\n}\n.news-nav .news-wrapper[data-v-e94b9680]{height:331px;box-sizing:border-box\n}\n.news-nav .news-wrapper .news-container[data-v-e94b9680]{width:1080px;height:331px;margin:0 auto;position:relative\n}\n.news-nav .news-wrapper .news-container .news-content[data-v-e94b9680]{position:absolute;z-index:1;width:1080px;height:331px;display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;-ms-grid-row-align:center;align-items:center;overflow:hidden\n}\n.news-item[data-v-e94b9680]{height:331px;width:312px;cursor:pointer;position:relative;overflow:hidden\n}\n.news-item .item-bg-img[data-v-e94b9680]{height:331px;width:322px;background-size:322px 331px;background-position:top left;margin-left:0;transition:all .3s linear\n}\n.news-item .mask[data-v-e94b9680]{position:absolute;left:0;top:0;height:331px;width:312px;background:rgba(0,0,0,0.5)\n}\n.news-item .bottom-bg[data-v-e94b9680]{opacity:0.6;width:100%;height:0;background:#ffab27;position:absolute;bottom:0;transition:all .2s linear\n}\n.news-item .content[data-v-e94b9680]{position:absolute;top:0;left:0;height:331px;width:312px;z-index:10;color:#fff;text-align:center\n}\n.news-item .content .item-title[data-v-e94b9680]{padding:62px 10px 0;height:86px;box-sizing:border-box;transition:all .2s linear\n}\n.news-item .content p[data-v-e94b9680]{box-sizing:border-box;font-size:14px;line-height:20px\n}\n.news-item .content .item-desc[data-v-e94b9680]{position:absolute;bottom:125px;width:100%;left:0;top:70%;padding:0 50px;transition:all .2s linear\n}\n.news-item .content .item-like[data-v-e94b9680]{position:absolute;bottom:20px;width:100%;font-size:14px;transition:all .2s linear\n}\n.news-item .content .item-like[data-v-e94b9680]:hover{font-size:16px;transition:all .2s linear\n}\n.news-item .content .item-like:hover .link-heart[data-v-e94b9680]{color:red\n}\n.news-item:hover .item-bg-img[data-v-e94b9680]{margin-left:-10px;transition:all .3s linear\n}\n.news-item:hover .mask[data-v-e94b9680]{display:none\n}\n.news-item:hover .bottom-bg[data-v-e94b9680]{height:115px;opacity:1;transition:all .2s linear\n}\n.news-item[data-v-e94b9680]{background-repeat:no-repeat;background-position:top center\n}\n.news-list[data-v-e94b9680]{height:331px;width:456px;background:#333;position:relative\n}\n.news-list .plus[data-v-e94b9680]{color:#fff;position:absolute;top:0;right:0;width:0;height:0;border-top:45px solid #f5972d;border-left:45px solid transparent\n}\n.news-list .plus span[data-v-e94b9680]{position:absolute;top:-50px;right:2px;font-size:35px\n}\n.news-list .content[data-v-e94b9680]{padding:0 35px;margin-top:45px;box-sizing:border-box\n}\n.news-list .content .title[data-v-e94b9680]{font-size:31px;color:#f5972d\n}\n.news-list .content .title-empty[data-v-e94b9680]{height:44px\n}\n.news-list .content .list[data-v-e94b9680]{width:100%;border-top:1px solid gray;margin-top:10px;list-style:none\n}\n.news-list .content .list .li[data-v-e94b9680]{width:100%;margin-top:10px\n}\n.news-list .content .list .li a[data-v-e94b9680]{display:-ms-flexbox;display:flex;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;-ms-grid-row-align:center;align-items:center;text-decoration:none\n}\n.news-list .content .list .li a .title[data-v-e94b9680]{font-size:14px;color:#a6a6a6;-ms-flex-positive:1;flex-grow:1;-ms-flex-negative:1;flex-shrink:1;overflow:hidden;white-space:nowrap;text-overflow:ellipsis\n}\n.news-list .content .list .li a .title[data-v-e94b9680]:hover{color:#fff\n}\n.news-list .content .list .li a .date[data-v-e94b9680]{font-size:14px;color:#a6a6a6;width:80px;-ms-flex-positive:0;flex-grow:0;-ms-flex-negative:0;flex-shrink:0;text-align:right\n}\n"],"sourceRoot":"webpack://"}]);
	
	// exports


/***/ }),

/***/ 296:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(246);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-43bba9cf&scoped=true!../../../node_modules/sass-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./HotGames.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-43bba9cf&scoped=true!../../../node_modules/sass-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./HotGames.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 302:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(250);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../node_modules/css-loader/index.js?sourceMap!../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-5a027f44&scoped=true!../../node_modules/sass-loader/index.js?sourceMap!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Home.vue", function() {
				var newContent = require("!!../../node_modules/css-loader/index.js?sourceMap!../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-5a027f44&scoped=true!../../node_modules/sass-loader/index.js?sourceMap!../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Home.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 308:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(256);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-944db24e&scoped=true!../../../node_modules/sass-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./PartItem.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-944db24e&scoped=true!../../../node_modules/sass-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./PartItem.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 312:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(260);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-c2b5e786&scoped=true!../../../node_modules/sass-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Partner.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-c2b5e786&scoped=true!../../../node_modules/sass-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Partner.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 314:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(262);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-d50b428a&scoped=true!../../../node_modules/sass-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Carousel.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-d50b428a&scoped=true!../../../node_modules/sass-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./Carousel.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 316:
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(264);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(3)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-e94b9680&scoped=true!../../../node_modules/sass-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./GameNews.vue", function() {
				var newContent = require("!!../../../node_modules/css-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter.js?id=data-v-e94b9680&scoped=true!../../../node_modules/sass-loader/index.js?sourceMap!../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./GameNews.vue");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),

/***/ 344:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(302)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(142),
	  /* template */
	  __webpack_require__(380),
	  /* scopeId */
	  "data-v-5a027f44",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 351:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(314)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(149),
	  /* template */
	  __webpack_require__(392),
	  /* scopeId */
	  "data-v-d50b428a",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 352:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(316)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(150),
	  /* template */
	  __webpack_require__(394),
	  /* scopeId */
	  "data-v-e94b9680",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 353:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(296)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(151),
	  /* template */
	  __webpack_require__(374),
	  /* scopeId */
	  "data-v-43bba9cf",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 354:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(312)
	
	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(152),
	  /* template */
	  __webpack_require__(390),
	  /* scopeId */
	  "data-v-c2b5e786",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 374:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('part-item', {
	    attrs: {
	      "title": _vm.$t('hotGames')
	    }
	  }, [_c('div', {
	    staticClass: "refresh",
	    on: {
	      "click": _vm.shuffleGames
	    },
	    slot: "header-right"
	  }, [_vm._v("\n            " + _vm._s(_vm.$t('changeGames'))), _c('i', {
	    staticClass: "fa fa-refresh",
	    attrs: {
	      "aria-hidden": "true"
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "hot-games"
	  }, _vm._l((_vm.currentGames), function(game, index) {
	    return _c('div', {
	      key: index,
	      staticClass: "hot-game"
	    }, [_c('div', {
	      directives: [{
	        name: "lazy",
	        rawName: "v-lazy:background-image",
	        value: (game.hot_game_pic_url),
	        expression: "game.hot_game_pic_url",
	        arg: "background-image"
	      }],
	      staticClass: "top-bg",
	      on: {
	        "click": function($event) {
	          _vm.openWeb(game.detail_href)
	        }
	      }
	    }, [_c('div', {
	      staticClass: "game-qr"
	    }, [_c('div', {
	      staticClass: "qr-container"
	    }, [_c('img', {
	      staticClass: "qr",
	      attrs: {
	        "src": game.code_pic_url
	      }
	    }), _vm._v(" "), _c('div', {
	      staticClass: "right-desc"
	    }, [_c('p', [_vm._v(_vm._s(_vm.$t('gameType')) + "：" + _vm._s(game.type))]), _vm._v(" "), _c('div', {
	      staticClass: "rating"
	    }, [_c('p', [_vm._v(_vm._s(_vm.$t('gameRating')) + "：")]), _vm._v(" "), _c('div', {
	      staticClass: "stars"
	    }, _vm._l((5), function(i) {
	      return _c('i', {
	        staticClass: "fa fa-star"
	      })
	    }))])])])])]), _vm._v(" "), _c('div', {
	      staticClass: "bottom-desc"
	    }, [_c('h3', {
	      staticClass: "game-title"
	    }, [_vm._v(_vm._s(game.app_name))]), _vm._v(" "), _c('p', {
	      staticClass: "game-desc"
	    }, [_vm._v(_vm._s(game.big_title))]), _vm._v(" "), _c('div', {
	      staticClass: "links"
	    }, [_c('a', {
	      staticClass: "link-btn",
	      attrs: {
	        "href": game.detail_href,
	        "target": "_blank"
	      }
	    }, [_vm._v(_vm._s(_vm.$t('goToSite')))])])])])
	  }))])], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 380:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "home-page"
	  }, [_c('div', {
	    staticClass: "top-content"
	  }, [_c('carousel'), _vm._v(" "), _c('game-news')], 1), _vm._v(" "), _c('hot-games'), _vm._v(" "), _c('partner')], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 386:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "part-item"
	  }, [_c('div', {
	    staticClass: "item-header"
	  }, [_c('h1', {
	    staticClass: "item-title"
	  }, [_c('i', {
	    staticClass: "fa fa-stop part-item-title"
	  }), _vm._v(_vm._s(_vm.title))]), _vm._v(" "), _vm._t("header-right")], 2), _vm._v(" "), _vm._t("default")], 2)
	},staticRenderFns: []}

/***/ }),

/***/ 390:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('part-item', {
	    attrs: {
	      "title": _vm.$t('partner')
	    }
	  }, [_c('content-item', {
	    attrs: {
	      "marginTop": 0
	    }
	  }, [_c('div', {
	    staticClass: "partner-content"
	  }, _vm._l((4), function(row) {
	    return _c('div', {
	      staticClass: "hex-row",
	      class: row % 2 == 0 ? 'hex-gap' : ''
	    }, [(row % 2 == 0) ? _vm._l((8), function(col) {
	      return _c('div', {
	        staticClass: "hex-col"
	      }, [_c('div', {
	        staticClass: "hexagon",
	        class: 'icon' + row + '' + col
	      }, [(_vm.showIcon(row, col)) ? _c('div', {
	        staticClass: "content"
	      }, [_c('img', {
	        directives: [{
	          name: "lazy",
	          rawName: "v-lazy",
	          value: ('../../../static/img/home/brand_icon/icon' + row + '' + col + '.png'),
	          expression: "'../../../static/img/home/brand_icon/icon' + row + '' + col + '.png'"
	        }],
	        staticClass: "icon"
	      })]) : _vm._e()])])
	    }) : _vm._l((8), function(col) {
	      return _c('div', {
	        staticClass: "hex-col"
	      }, [_c('div', {
	        staticClass: "hexagon",
	        class: 'icon' + row + '' + col
	      }, [(_vm.showIcon(row, col)) ? _c('div', {
	        staticClass: "content"
	      }, [_c('img', {
	        directives: [{
	          name: "lazy",
	          rawName: "v-lazy",
	          value: ('../../../static/img/home/brand_icon/icon' + row + '' + col + '.png'),
	          expression: "'../../../static/img/home/brand_icon/icon' + row + '' + col + '.png'"
	        }],
	        staticClass: "icon"
	      })]) : _vm._e()])])
	    })], 2)
	  }))])], 1)], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 392:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "page-home-carousel"
	  }, [(_vm.show_flag) ? _c('el-carousel', {
	    attrs: {
	      "interval": 5000,
	      "arrow": "always",
	      "height": "757px"
	    },
	    on: {
	      "change": _vm.imgAnimation
	    }
	  }, _vm._l((_vm.sliders), function(slider, index) {
	    return _c('el-carousel-item', {
	      staticClass: "slider-item",
	      style: ('background-image:url(' + slider.bg_pic_url + ')')
	    }, [_c('div', {
	      staticClass: "item-content"
	    }, [_c('div', {
	      staticClass: "item-img",
	      class: 'item-img' + (index + 1),
	      style: ('background-image:url(' + slider.person_pic_url + ')')
	    }), _vm._v(" "), _c('div', {
	      staticClass: "item-desc",
	      class: 'item-desc' + (index + 1)
	    }, [_c('img', {
	      staticClass: "game-logo",
	      class: 'game-logo' + (index + 1),
	      attrs: {
	        "src": slider.logo_pic_url
	      }
	    }), _vm._v(" "), _c('h1', {
	      staticClass: "game-title"
	    }, [_vm._v(_vm._s(slider.big_title))]), _vm._v(" "), _c('div', {
	      staticClass: "orange-line"
	    }), _vm._v(" "), _c('p', {
	      staticClass: "game-desc"
	    }, [_vm._v(" " + _vm._s(slider.tips))]), _vm._v(" "), _c('a', {
	      staticClass: "detail-link",
	      attrs: {
	        "href": slider.detail_href,
	        "target": "_blank"
	      }
	    }, [_vm._v(_vm._s(_vm.$t('checkDetail')))])])])])
	  })) : _vm._e()], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 394:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "news-nav"
	  }, [_c('div', {
	    staticClass: "orange-bg"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "news-wrapper"
	  }, [_c('div', {
	    staticClass: "news-container"
	  }, [_c('div', {
	    staticClass: "news-content"
	  }, [_vm._l((_vm.allAppNews), function(appNews) {
	    return _c('div', {
	      staticClass: "news-item"
	    }, [_c('div', {
	      directives: [{
	        name: "lazy",
	        rawName: "v-lazy:background-image",
	        value: (appNews.near_news_pic_url),
	        expression: "appNews.near_news_pic_url",
	        arg: "background-image"
	      }],
	      staticClass: "item-bg-img"
	    }), _vm._v(" "), _c('div', {
	      staticClass: "mask"
	    }), _vm._v(" "), _c('div', {
	      staticClass: "content",
	      on: {
	        "click": function($event) {
	          _vm.openWeb(appNews.detail_href)
	        }
	      }
	    })])
	  }), _vm._v(" "), _c('div', {
	    staticClass: "news-list"
	  }, [_c('router-link', {
	    staticClass: "plus",
	    attrs: {
	      "to": "news"
	    }
	  }, [_c('span', [_vm._v("+")])]), _vm._v(" "), _c('div', {
	    staticClass: "content"
	  }, [(_vm.allNews.length > 0) ? _c('router-link', {
	    staticStyle: {
	      "text-decoration": "none"
	    },
	    attrs: {
	      "to": 'news/' + _vm.allNews[0].id
	    }
	  }, [_c('h1', {
	    staticClass: "title"
	  }, [_vm._v(_vm._s(_vm.allNews[0].title))])]) : _vm._e(), _vm._v(" "), _c('ul', {
	    staticClass: "list"
	  }, _vm._l((_vm.allNews), function(news, index) {
	    return (index >= 1 && index <= 5) ? _c('li', {
	      staticClass: "li"
	    }, [_c('router-link', {
	      attrs: {
	        "to": 'news/' + news.id
	      }
	    }, [_c('p', {
	      staticClass: "title"
	    }, [_vm._v("[" + _vm._s(_vm.$t('typeNews')) + "] " + _vm._s(news.title))]), _vm._v(" "), _c('p', {
	      staticClass: "date"
	    }, [_vm._v(_vm._s(news.news_date))])])], 1) : _vm._e()
	  }))], 1)], 1)], 2)])])])
	},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/1.8d6926e851251946bccb.js